import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"
/* hot reload */
if (module.hot) {
  script.__hmrId = "113a57a9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('113a57a9', script)) {
    api.reload('113a57a9', script)
  }
  
}

script.__file = "resources/ts/App.vue"

export default script